"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionMetadataRequestToJSON = exports.RosettaConstructionMetadataRequestFromJSONTyped = exports.RosettaConstructionMetadataRequestFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionMetadataRequestFromJSON(json) {
    return RosettaConstructionMetadataRequestFromJSONTyped(json, false);
}
exports.RosettaConstructionMetadataRequestFromJSON = RosettaConstructionMetadataRequestFromJSON;
function RosettaConstructionMetadataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'options': _1.RosettaOptionsFromJSON(json['options']),
        'public_keys': !runtime_1.exists(json, 'public_keys') ? undefined : (json['public_keys'].map(_1.RosettaPublicKeyFromJSON)),
    };
}
exports.RosettaConstructionMetadataRequestFromJSONTyped = RosettaConstructionMetadataRequestFromJSONTyped;
function RosettaConstructionMetadataRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'options': _1.RosettaOptionsToJSON(value.options),
        'public_keys': value.public_keys === undefined ? undefined : (value.public_keys.map(_1.RosettaPublicKeyToJSON)),
    };
}
exports.RosettaConstructionMetadataRequestToJSON = RosettaConstructionMetadataRequestToJSON;
//# sourceMappingURL=RosettaConstructionMetadataRequest.js.map